
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M26.993,38.965c-1.646,1.647-4.341,1.647-5.986,0L9.035,26.992c-1.646-1.646-1.646-4.341,0-5.985\n\t\t\tL21.007,9.035c1.646-1.646,4.341-1.646,5.986,0l11.972,11.972c1.646,1.645,1.646,4.341,0,5.985L26.993,38.965z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#B7C3D7",
                "d": "M18.417,26.115h3.438v3.436c0,0.93,0.75,1.682,1.682,1.682h0.98c0.927,0,1.682-0.752,1.682-1.682v-3.436\n\t\t\th3.434c0.932,0,1.684-0.753,1.684-1.682v-0.98c0-0.93-0.752-1.682-1.684-1.682h-3.434v-3.438c0-0.929-0.755-1.681-1.682-1.681\n\t\t\th-0.98c-0.932,0-1.682,0.752-1.682,1.681v3.438h-3.438c-0.927,0-1.681,0.752-1.681,1.682v0.98\n\t\t\tC16.736,25.362,17.49,26.115,18.417,26.115z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  